@let widget =
  widgetsEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();

@if (widget) {
  <div class="atn-mosaic-dev-widget-general-tab">
    <div class="atn-mosaic-dev-widget-general-tab__content">
      <atn-ds-text
        label="Name"
        placeholder="Enter a name"
        [value]="widget.name"
        (change)="updateWidget('name', $event ?? '')"
      ></atn-ds-text>
      <atn-ds-text
        label="Alias"
        placeholder="Used to reference this widget"
        [value]="widget.alias"
        (change)="updateWidget('alias', $event ?? '')"
      ></atn-ds-text>
      <atn-ds-text
        label="Description"
        placeholder="Enter a description"
        [value]="widget.description"
        (change)="updateWidget('description', $event)"
      ></atn-ds-text>
      <atn-ds-code
        class="atn-mosaic-dev-widget-general-tab__query-editor"
        label="Query"
        syntax="dms-query"
        [json]="widget.query"
        (jsonChange)="updateWidgetQuery($event)"
        (execute)="runQuery('QueryEditor.ExecuteAction.Ran')"
      />
    </div>
    <div class="atn-mosaic-dev-widget-general-tab__preview">
      @let preview =
        this.widgetPreviewPlugin.feature.selectors.currentWidgetPreview.asSignal();
      @let error =
        widgetPreviewPlugin.feature.selectors.currentWidgetPreviewError.asSignal();
      @let isLoading =
        !!widgetPreviewPlugin.feature.selectors.currentWidgetPreviewIsLoading.asSignal();

      <atn-ds-floating-horizontal-tabs>
        <ng-template
          atnDsTab
          name="Design view"
        >
          <atn-mosaic-widget
            [rendering]="preview"
            [refId]="widgetRefIdForPreview"
            [loading]="isLoading"
            [error]="error"
          />
        </ng-template>
        <ng-template
          atnDsTab
          name="JSON view"
        >
          <atn-ds-code
            syntax="json"
            [value]="
              preview
                ? (preview | json)
                : isLoading
                  ? 'loading...'
                  : error?.message
            "
            [readonly]="true"
          />
        </ng-template>
      </atn-ds-floating-horizontal-tabs>
    </div>
  </div>
}
